(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sections = document.querySelectorAll('.pf-reveal');

  if (reduceMotion || !('IntersectionObserver' in window)) {
    sections.forEach((section) => section.classList.add('is-visible'));
    return;
  }

  document.documentElement.classList.add('pf-motion-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
  );

  requestAnimationFrame(() => {
    sections.forEach((section) => observer.observe(section));
  });

  document.querySelectorAll('.site-header__mobile-menu nav a').forEach((link) => {
    link.addEventListener('click', () => {
      link.closest('details')?.removeAttribute('open');
    });
  });

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('.pf-reveal').forEach((section) => {
      section.classList.add('is-visible');
    });
  });
})();
